import { useEffect, useState } from "react";
import { useApi, ApiError } from "./api";

export interface ActivitySummary {
  lessonsCompletedCount: number;
  lessonsCompletedThisWeek: number;
  chaptersCompletedCount: number;
  chaptersTotal: number;
  daysActive7d: number;
  daysActive30d: number;
}

export type ActivityState =
  | { status: "loading" }
  | { status: "error"; message: string }
  | { status: "ready"; summary: ActivitySummary };

export function useActivitySummary(): ActivityState {
  const { apiFetch } = useApi();
  const [state, setState] = useState<ActivityState>({ status: "loading" });
  useEffect(() => {
    let cancelled = false;
    apiFetch<ActivitySummary>("/api/activity/summary")
      .then((summary) => { if (!cancelled) setState({ status: "ready", summary }); })
      .catch((err: unknown) => {
        if (cancelled) return;
        const msg = err instanceof ApiError
          ? `${err.code}: ${err.message}`
          : err instanceof Error
            ? err.message
            : "Unknown error";
        setState({ status: "error", message: msg });
      });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return state;
}
